import { getCurrentInstance } from 'vue';

export default () => {
  const ctx = getCurrentInstance().proxy;
  return ctx.$router;
};
